import { ReactElement } from "react"
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query"
import { IChoiceOption } from "interfaces/xlsForm"
import useCommon from "hooks/useCommon"
import { useSaveChoiceMutation, useGetChoicesOptionQuery } from "services/household/xlsFormSchemas"
import ChoicesList from "components/Household/Form/ChoicesList"

interface Props {
  xlsFormId: number
  permissions: boolean
}

const BaseXlsFormChoiceList = ({ xlsFormId, permissions }: Props): ReactElement => {
  const { showSnackBar } = useCommon()

  const { data: choicesList } = useGetChoicesOptionQuery({ xlsFormId }, { skip: !xlsFormId })
  const [saveChoice, { isLoading: loadingSaveChoice }] = useSaveChoiceMutation()

  const onChoiceSave = async (payload: IChoiceOption, onClose: () => void): Promise<void> => {
    try {
      await saveChoice({ xlsFormId, ...payload }).unwrap()
      showSnackBar("Choice saved successfully")
      onClose()
    } catch (err) {
      const error = err as FetchBaseQueryError
      showSnackBar((error?.data as { message: string })?.message ?? "Choice save failed", "error")
    }
  }

  return (
    <ChoicesList
      xlsFormId={xlsFormId}
      permissions={permissions}
      saveChoice={onChoiceSave}
      loadingSaveChoice={loadingSaveChoice}
      list={choicesList ?? []}
    />
  )
}

export default BaseXlsFormChoiceList
